import { FC } from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router";
import MaintenanceParts from "./MaintenanceParts";

interface Category {
  id: string;
  name: string;
  image: string;
  link: string;
}

const categories: Category[] = [
  {
    id: "1",
    name: "Моторные\nмасла",
    image: "/images/category-motor-oil.png",
    link: "/category/e276d40a-9721-11e1-82a9-00e052d08354",
  },
  {
    id: "2",
    name: "Маслянные\nфильтры",
    image: "/images/category-oil-filters.png",
    link: "/category/65cdefa3-11e9-11e0-b310-0016eab4cd54",
  },
  {
    id: "3",
    name: "Воздушные\nфильтры",
    image: "/images/category-air-filters.png",
    link: "/category/3ee43c7a-11e9-11e0-b310-0016eab4cd54",
  },
  {
    id: "4",
    name: "Фильтры\nсалона",
    image: "/images/category-cabin-filters.png",
    link: "/category/9eeda6a6-11e9-11e0-b310-0016eab4cd54",
  },
  {
    id: "5",
    name: "Топливные\nфильтры",
    image: "/images/category-fuel-filters.png",
    link: "/category/b1118300-11e9-11e0-b310-0016eab4cd54",
  },
  {
    id: "6",
    name: "Свечи\nзажигания",
    image: "/images/category-spark-plugs.png",
    link: "/category/9eeda73f-11e9-11e0-b310-0016eab4cd54",
  },
  {
    id: "7",
    name: "Тормозные\nколодки",
    image: "/images/category-brake-pads.png",
    link: "/category/58c8806d-11e9-11e0-b310-0016eab4cd54",
  },
  {
    id: "8",
    name: "Тормозные\nдиски",
    image: "/images/category-brake-discs.png",
    link: "/category/4bc22707-11e9-11e0-b310-0016eab4cd54",
  },
];

const CategoriesGrid: FC = () => {
  return (
    <div className="flex flex-col gap-[25px] md:h-[450px]">
      <h2 className="text-[#232323] text-[20px] md:text-[27px] font-bold tracking-[-0.54px]">
        Популярные категории
      </h2>

      {/* Mobile Layout - Single Column */}
      <div className="flex flex-col gap-[25px] md:hidden">
        <MaintenanceParts />
        <div className="grid grid-cols-2 gap-[15px]">
               {categories.map((category, index) => (
          <div key={category.id}>
            <Link
              to={category.link}
              className="bg-white rounded-[15px] flex flex-col overflow-hidden items-start justify-between h-[134px] shadow-[0px_2px_20px_rgba(0,0,0,0.10)] hover:shadow-[0px_4px_24px_rgba(0,0,0,0.15)] transition-shadow group"
            >
              <div className="flex items-start p-[15px] justify-between w-full">
                <span className="text-[#262626] text-[18px] font-bold tracking-[-0.36px] whitespace-pre-line leading-[22px]">
                  {category.name}
                </span>
                <ChevronRight className="w-[21px] h-[21px] text-[#262626] group-hover:translate-x-1 transition-transform flex-shrink-0" />
              </div>
              <img
                src={category.image}
                alt={category.name.replace("\n", " ")}
                className="w-auto max-h-[67px] object-contain self-end"
              />
            </Link>
          </div>
        ))}
        </div>
      </div>

      {/* Desktop Layout - Grid with MaintenanceParts on Side */}
      <div className="hidden md:flex flex-row gap-[30px] w-full">
        <div className="grid grid-cols-2 gap-[20px] w-full grid-rows-[repeat(2,150px)]">
          {categories.slice(0, 4).map((category) => (
            <Link
              key={category.id}
              to={category.link}
              className="bg-white rounded-[15px] flex flex-col items-start overflow-hidden justify-between h-[150px] shadow-[0px_2px_20px_rgba(0,0,0,0.10)] hover:shadow-[0px_4px_24px_rgba(0,0,0,0.15)] transition-shadow group"
            >
              <div className="flex items-start p-[15px] justify-between w-full">
                <span className="text-[#262626] text-[18px] font-bold tracking-[-0.36px] whitespace-pre-line leading-[22px]">
                  {category.name}
                </span>
                <ChevronRight className="w-[24px] h-[24px] text-[#282828] group-hover:translate-x-1 transition-transform" />
              </div>
              <img
                src={category.image}
                alt={category.name.replace("\n", " ")}
                className="w-auto h-[80px] object-contain self-end"
              />
            </Link>
          ))}
        </div>

        <div className="w-[440px] flex-shrink-0">
          <MaintenanceParts />
        </div>

        <div className="grid grid-cols-2 gap-[20px] w-full grid-rows-[repeat(2,150px)]">
          {categories.slice(4, 8).map((category) => (
            <Link
              key={category.id}
              to={category.link}
              className="bg-white rounded-[15px] overflow-hidden  flex flex-col items-start justify-between h-[150px] shadow-[0px_2px_20px_rgba(0,0,0,0.10)] hover:shadow-[0px_4px_24px_rgba(0,0,0,0.15)] transition-shadow group"
            >
              <div className="flex p-[15px] items-start justify-between w-full overflow-hidden">
                <span className="text-[#262626] text-[18px] font-bold tracking-[-0.36px] whitespace-pre-line leading-[22px]">
                  {category.name}
                </span>
                <ChevronRight className="w-[24px] h-[24px] text-[#282828] group-hover:translate-x-1 transition-transform" />
              </div>
              <img
                src={category.image}
                alt={category.name.replace("\n", " ")}
                className="w-auto h-[80px] object-cover self-end"
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoriesGrid;
